module.exports = __webpack_public_path__ + "media/src/images/icons/flags/germany-d6db7ad3f23303a4970aaa312ba83a53.svg";